import React from "react";
import "./footer.scss";
import logo from "../../../media/logo-kbp.png";

const footer = () => {
  return (
    <div className="container-footer">
      <div className="container-atas">
        <div className="container-logo">
          <img
            className="gambar-logo"
            src={logo}
            alt="logo-citraland-surabaya"
          />
        </div>
        <div className="container-deskripsi">
          <div className="alamat">
            <h1>Marketing Gallery</h1>
            <h2>Kota Baru Parahyangan</h2>
            <h3>
              Jalan Naga Wijaya Wetan No.12, Kertajaya, Kec. Padalarang,
              Kabupaten Bandung Barat, Jawa Barat 40553
            </h3>
            <h4>Contact us : +6285720445400 (Rizki)</h4>
          </div>
          <div className="privasi"></div>
        </div>
      </div>
      <div className="container-bawah">© 2024 All Rights Reserved.</div>
    </div>
  );
};

export default footer;
